import type { Stop } from '@common/types/Stop'
import { mapOrd, rawOrd } from '@lc/libarray'
import {
	createEntityAdapter,
	createSlice,
	type WithSlice,
} from '@reduxjs/toolkit'
import { reducer } from './store'

export const stopsAdapter = createEntityAdapter({
	selectId: (stop: Stop) => stop.id,
	sortComparer: mapOrd(rawOrd, stop => stop.id),
})

declare module './store' {
	// eslint-disable-next-line @typescript-eslint/no-empty-object-type
	export interface LoadedSlices extends WithSlice<typeof stopsSlice> {}
}

const { selectById, selectIds, selectEntities } = stopsAdapter.getSelectors()

export type StopsSlice = ReturnType<(typeof stopsSlice)['getInitialState']>
export const stopsSlice = createSlice({
	name: 'stops',
	initialState: stopsAdapter.getInitialState<{ hoveredStop: string | null }>({
		hoveredStop: null,
	}),
	reducers: {
		setStop: stopsAdapter.setOne,
		setStops: stopsAdapter.setMany,

		delStop: stopsAdapter.removeOne,
		delStops: stopsAdapter.removeMany,

		insertStops: stopsAdapter.addMany,

		clearStops: stopsAdapter.removeAll,
		initStops: stopsAdapter.setAll,
		// setHoveredStop: (state, action: PayloadAction<string | null>) => {
		// 	state.hoveredStop = action.payload
		// },
	},
	selectors: {
		getAllStops: selectEntities,
		getStop: (state, id: string): Stop | undefined => selectById(state, id),
		listStops: selectIds,
	},
})

export const {
	reducer: stopsReducer,
	actions: {
		setStop,
		setStops,
		delStop,
		delStops,
		insertStops,
		clearStops,
		initStops,
		// setHoveredStop,
	},
	selectors: { getStop, listStops, getAllStops },
} = stopsSlice.injectInto(reducer)
